import { Component, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageKeyEnum } from 'src/app/localStorage.key.enum';
import { AsyncDropdown } from 'src/app/models/async-dropdown';
import { FireworksService } from 'src/app/services/fireworks.service';
import { ToastService } from 'src/app/services/toast.service';
import { ProjectDetails } from 'src/app/user/project/models/project-details';
import { SendEmailComponent } from 'src/app/user/project/send-email/send-email.component';
import { ProjectDetailsService } from 'src/app/user/project/service/project-details.service';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { ProjectNewService } from '../service/project-new.service';
import { ProjectsService } from '../service/projects.service';
import { JiraTemplatesDropdown } from './models/jira-templates';
import { ProjectCreationSuccessComponent } from './project-creation-success/project-creation-success.component';
@Component({
  selector: 'apc-new-order-budget-project',
  templateUrl: './new-project.component.html',
  styleUrls: ['./new-project.component.scss'],
  providers: [ProjectsService, ProjectDetailsService],
})
export class NewProjectComponent {
  public form: UntypedFormGroup = null;
  public jiraTemplates: JiraTemplatesDropdown[] = [];
  public jiraTemplatesLoading: boolean = false;
  public loadingUsers: boolean = false;
  public noUsersResult: boolean = false;
  public modalRef: any;
  public questionModalRef: any;
  public successProjectCreationRef: any;
  public globalResponse: any;
  @Output() backEvent = new EventEmitter<boolean>();
  @Output() operationSuccess = new EventEmitter<any>();
  @Input() budgetId: string;
  @Input() budget: any;
  @Output()
  jiraUsers: Array<string> = [];
  triggerFunnerlDetailSubscrition: any;
  constructor(
    private toastService: ToastService,
    private projectService: ProjectsService,
    private projectDetailsService: ProjectDetailsService,
    private fireworksService: FireworksService,
    private projectNewService: ProjectNewService,
    public translate: TranslateService,
    public modalService: NgbModal,
  ) { }


  ngOnInit() {
    this.initSingleForm();
  }

  ngOnDestory() {
    this.triggerFunnerlDetailSubscrition.unsubscribe();
  }

  initSingleForm() {
    this.form = new UntypedFormGroup({
      budgetIdentifier: new UntypedFormControl(),
      name: new UntypedFormControl(null, [Validators.required]),
      description: new UntypedFormControl(null),
      template: new UntypedFormControl(null, [Validators.required]),
      addLoggedUser: new UntypedFormControl(true, [Validators.required]),
      projectManagers: new UntypedFormControl(null, this.budget?.type?.projectManagerRequired ? [Validators.required] : null),
      jiraKey: new UntypedFormControl(null),
    });
  }

  initDropdowns(data: any) {
    this.jiraTemplates.push(data.customer || new AsyncDropdown());
  }

  async fetchTemplates() {
    this.jiraTemplates = [];
    this.jiraTemplatesLoading = true;
    this.jiraTemplates = await this.projectService.getJiraTemplates();
    this.jiraTemplatesLoading = false;
  }

  async createProject(e) {
    this.form.controls.budgetIdentifier.patchValue(this.budgetId);
    // this.form.controls.projectManagers.patchValue(this.jiraUsers);
    if (this.form.valid) {
      this.projectService
        .createProject(this.form.value)
        .then((response: any) => {
          this.toastService.showSuccess('Operation Success!');
          this.showFireworks();
          this.operationSuccess.emit(response);
          // raise new modal and ask if user wants to send an email #565
          this.openProjectSuccessDetails(
            response.jiraProjectActions,
            response.project.name,
            response.project.jiraKey
          );
          this.triggerFunnerlDetailSubscrition = this.projectNewService._triggerFunnelDetail$.subscribe((canOpen) => {
            console.log("triggerFunnerlDetailSubscrition", canOpen);
            if (canOpen) {
              this.projectDetailsService
                .getProjectDetails(response.project.identifier)
                .then((proj: ProjectDetails) => {
                  let budgetsToShow = proj.projectBudgets;
                  this.openSendDetailsModal(
                    response.project.identifier,
                    budgetsToShow,
                    this.form.value.projectManagers,
                    response.jiraProjectActions,
                    response.project.name,
                    response.project.jiraKey
                  );
                });
            }
          });
          this.questionModalRef.result.then(
            (res) => { },
            (answer) => {
              if (answer) {
                console.log("Else openProjectSuccessDetails", answer);

                this.projectDetailsService
                  .getProjectDetails(response.project.identifier)
                  .then((proj: ProjectDetails) => {
                    let budgetsToShow = proj.projectBudgets;
                    this.openSendDetailsModal(
                      response.project.identifier,
                      budgetsToShow,
                      this.form.value.projectManagers,
                      response.jiraProjectActions,
                      response.project.name,
                      response.project.jiraKey
                    );
                  });
              } else {
                console.log("Else openProjectSuccessDetails");
                this.openProjectSuccessDetails(
                  response.jiraProjectActions,
                  response.project.name,
                  response.project.jiraKey
                );
              }
            }
          );
        })
        .catch((error) => {
          checkForValidationErrors(error, this.form);
        });
    } else {
      this.toastService.showError('Please check marked fields!');
      this.form.markAsPristine();
      this.form.markAllAsTouched();
    }
  }

  openSendDetailsModal(projectId, budgets, users, urls, projectName, projectKey) {
    this.modalRef = this.modalService.open(SendEmailComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-project-modal',
    });
    this.modalRef.componentInstance.modalRef = this.modalRef;
    this.modalRef.componentInstance.budgets = budgets;
    this.modalRef.componentInstance.projectId = projectId;
    setTimeout(() => {
      this.modalRef.componentInstance.form.controls.budgets.patchValue(budgets);
      this.modalRef.componentInstance.form.controls.emailAddresses.patchValue(users);
    }, 200);

    this.modalRef.result.then(
      (res) => {
        this.openProjectSuccessDetails(urls, projectName, projectKey);
      },
      () => {
        this.openProjectSuccessDetails(urls, projectName, projectKey);
      },
      () => {
        this.openProjectSuccessDetails(urls, projectName, projectKey);
      }
    );
  }

  openProjectSuccessDetails(urls: any, projectName: string, projectKey: string) {
    this.successProjectCreationRef = this.modalService.open(ProjectCreationSuccessComponent, {
      ariaLabelledBy: 'modal-basic',
      backdrop: 'static',
      keyboard: false,
      windowClass: 'budget-project-modal-success',
    });
    this.successProjectCreationRef.componentInstance.modalRef = this.successProjectCreationRef;
    this.successProjectCreationRef.componentInstance.projectUrl = urls.projectUrl;
    this.successProjectCreationRef.componentInstance.projectDataUrl = urls.projectDataUrl;
    this.successProjectCreationRef.componentInstance.userManagementUrl = urls.userManagementUrl;
    this.successProjectCreationRef.componentInstance.projectName = projectName;
    this.successProjectCreationRef.componentInstance.projectKey = projectKey;
    this.successProjectCreationRef.componentInstance.workspaceResourceUrl = urls.workspaceResourceUrl;
  }

  cancel() {
    this.backEvent.emit();
  }

  getJiraUsers = (text: string): Observable<any> => {
    if (text.length > 0) {
      this.loadingUsers = true;
      this.noUsersResult = false;
      return this.projectService.getJiraUsers(text.toLowerCase()).pipe(
        map((usersSuggestion) => {
          this.loadingUsers = false;
          if (!usersSuggestion.length) {
            this.noUsersResult = true;
          }
          return usersSuggestion.map((item: any) => {
            return item;
          });
        })
      );
    } else {
      this.noUsersResult = false;
    }
  };

  textChange = (text: string) => {
    if (text.length == 0) {
      this.noUsersResult = false;
    }
  }

  addMyself() {
    var email = JSON.parse(localStorage.getItem(LocalStorageKeyEnum.USER)).email.toLowerCase();
    if (!this.jiraUsers.find((el: any) => el.emailAddress === email)) {
      this.loadingUsers = true;
      this.projectService
        .getJiraUsers(email)
        .toPromise()
        .then((res: any) => {
          this.loadingUsers = false;
          if (res && res.length > 0) {
            var users = this.form.controls.projectManagers.value;
            if (!users || users.length == 0) {
              users = [];
              users.push(res[0]);
            } else if (users.length > 0 && !users.find((el) => el.username === email)) {
              users.push(res[0]);
            }
            this.form.controls.projectManagers.patchValue(users);
          }
        });
    }
  }
  showFireworks() {
    this.fireworksService.playTemporaryFireworks()
  }
}
